export default {
    "validation": {
        "min": "Der Mindestwert ist {min}",
        "max": "Der Wert kann nicht größer sein als {max}",
        "required": "Dies ist ein Mussfeld",
        "requiredTrue": "Dieses Feld muss ausgefüllt werden",
        "email": "Eine gültige E-Mail-Adresse ist einzutragen",
        "minLength": "Die Mindestlänge des Wertes beträgt {requiredLength, plural, one {# Zeichen} other {# Zeichen}}",
        "maxLength": "Der Wert darf nicht mehr als {requiredLength, plural, one {# Zeichen} other {# Zeichen}} haben",
        "pattern": "Der Wert ist ungültig",
        "unique": "Dieses Feld muss eindeutig sein",
        "integer": "Der Wert muss eine ganze Zahl sein",
        "number": "Der Wert muss eine Nummer sein",
        "date": "",
        "range": "Der erste Wert muss kleiner oder gleich dem zweiten Wert sein"
    }
};
